(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-booking-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cc-booking-page]');
    if (!root) return;

    /* Existing booking-page tracking */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ViewBookingPage',
      page_type: 'booking_page'
    });

    document.dispatchEvent(
      new CustomEvent('cc:ViewBookingPage', {
        detail: {
          page_type: 'booking_page'
        }
      })
    );

    /* Prevent Meta ViewContent from firing more than once */
    if (window.__ccBookingViewContentFired) return;

    const fireMetaViewContent = () => {
      if (typeof window.fbq !== 'function') {
        return false;
      }

      window.fbq('track', 'ViewContent', {
        content_name: 'Pottery Painting Booking',
        content_category: 'Pottery Workshop'
      });

      window.__ccBookingViewContentFired = true;
      return true;
    };

    /* Fire immediately if Meta Pixel is already loaded */
    if (fireMetaViewContent()) return;

    /*
      Meta Pixel may load slightly after this section.
      Check briefly until fbq becomes available.
    */
    let attempts = 0;

    const pixelCheck = setInterval(() => {
      attempts += 1;

      if (fireMetaViewContent() || attempts >= 20) {
        clearInterval(pixelCheck);
      }
    }, 250);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-date-friends-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cc-date-landing]');
    if (!root) return;

    const pushEvent = (name, detail = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...detail });
      document.dispatchEvent(new CustomEvent(`cc:${name}`, { detail }));
    };

    pushEvent('ViewLandingPage', { page_type: 'date_friends_landing' });

    root.addEventListener('click', (event) => {
      const target = event.target.closest('[data-cc-event]');
      if (!target) return;
      pushEvent(target.dataset.ccEvent, {
        label: target.textContent.trim(),
        href: target.getAttribute('href') || ''
      });
    });

    const pricing = root.querySelector('[data-cc-pricing]');
    if (pricing && 'IntersectionObserver' in window) {
      let seen = false;
      const observer = new IntersectionObserver((entries) => {
        if (seen) return;
        if (entries.some((entry) => entry.isIntersecting)) {
          seen = true;
          pushEvent('ScrollToPricing', { page_type: 'date_friends_landing' });
          observer.disconnect();
        }
      }, { threshold: 0.35 });
      observer.observe(pricing);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-gift-card-detail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!document.querySelector('[data-cc-gift-card-detail]') || !window.ccCRO) return;
    window.ccCRO.emit('ViewGiftCard', {
      page_type: 'gift_card',
      source_context: 'product_page'
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches('select[name="id"], input[name="id"]') || !window.ccCRO) return;
      window.ccCRO.emit('SelectGiftValue', {
        page_type: 'gift_card',
        source_context: 'variant_selection',
        variant_id: event.target.value
      });
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form.matches('form[action*="/cart/add"]') || !window.ccCRO) return;
      window.ccCRO.emit('AddGiftCardToCart', {
        page_type: 'gift_card',
        source_context: 'product_form'
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
